import {
  FDBodyText, FDBox, FDPrimaryActionButton, FDStack,
} from '@facet-wealth/design';
import React from 'react';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import MetaControl from 'Components/UI/Meta/MetaControl';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import {
  OutcomeUsed,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedPostSelectionNextUpActionsStepTemplate/Content/ActionsSection/OutcomeUsed/OutcomeUsed';
import { makeStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { Box } from '@mui/material';
import classNames from 'classnames';
import { dataAttrs } from 'Helpers/Testing';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(4),
  },
  show: {
    animation: '$fade-in 1s forwards',
  },
  hideOnRender: {
    visibility: 'hidden',
    overflow: 'hidden',
    height: 0,
  },
  hideViaButtonClick: {
    animation: '$fade-out 500ms forwards',
  },
  '@keyframes fade-in': {
    '0%': {
      maxHeight: '0px',
      opacity: 0,
      paddingBottom: theme.spacing(0),
    },
    '100%': {
      maxHeight: '400px',
      opacity: 1,
      paddingBottom: theme.spacing(4),
    },
  },
  '@keyframes fade-out': {
    '0%': {
      maxHeight: '400px',
      opacity: 1,
      paddingBottom: theme.spacing(4),
    },
    '100%': {
      maxHeight: '0px',
      opacity: 0,
      visibility: 'hidden',
      overflow: 'hidden',
      paddingBottom: theme.spacing(0),
    },
  },
}));

const metaOverrides = buildFacetDesignOverride()
  .nameOverride('outcomesUsedLabel', {
    _component: FDBodyText,
    _customProps: {
      size: 'lg',
    },
  }, overrideReadOnly);

export const AllGoalsForAction = ({ actionResource, setShowAllGoals, showAllGoals }) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const [hideViaButtonClick, setHideViaButtonClick] = React.useState(false);

  return (
    <Box className={classes.root}>
      <Box
        className={classNames(
          {
            [classes.show]: showAllGoals,
            [classes.hideOnRender]: !hideViaButtonClick && !showAllGoals,
            [classes.hideViaButtonClick]: hideViaButtonClick && !showAllGoals,
          },
        )}
      >
        <FDStack direction={'row'} spacing={1} justifyContent={'space-between'} {...dataAttrs('all-outcomes-for-action')}>
          <FDStack direction={'column'} spacing={2}>
            <MetaControl resource={actionResource} attrName={'outcomesUsedLabel'} metaOverrideSet={metaOverrides} />
            <FDStack spacing={2} paddingX={2} wrap>
              {actionResource.attr('outcomesUsed').resources().list().map((o) => <OutcomeUsed key={o.id()} resource={o} />)}
            </FDStack>
          </FDStack>
          <FDBox>
            <FDPrimaryActionButton
              label={'Hide goals'}
              onClick={() => {
                setHideViaButtonClick(true);
                setShowAllGoals(false);
              }}
              size={'sm'}
            />
          </FDBox>
        </FDStack>
      </Box>
    </Box>
  );
};

AllGoalsForAction.defaultProps = {
};

AllGoalsForAction.propTypes = {
  showAllGoals: PropTypes.bool.isRequired,
  setShowAllGoals: PropTypes.func.isRequired,
  actionResource: PropTypes.instanceOf(fr.Resource).isRequired,
};
